export default "__VITE_ASSET__24138c51__"